module.exports = __webpack_public_path__ + "img/1-sm.a6b5e7b2.jpg";